import { loader } from 'graphql.macro'

export default function reportsFiltersQuery ({ dataLoaders, queryKey }) {
  const [,
  ] = queryKey

  const reportsFiltersSchema = loader('./reportsFilters.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsFiltersSchema)
}
